// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RT62gYBXc5BXXdApE5y4{justify-content:space-between;align-items:center;width:calc(100% - 125px);margin-left:125px;padding:8px 12px;display:flex}.RT62gYBXc5BXXdApE5y4:hover{cursor:pointer;background:var(--background-neutral-subtle,#f6f7f8);border-radius:6px}.QeTWQmUqSXwxScsRYD8C,.U8D4Q62fQwCZod88_OIx{align-items:center;gap:8px;display:flex}.sGOKEtjb_4QuZq7djkzp{color:var(--content-neutral-primary);display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `RT62gYBXc5BXXdApE5y4`,
	"left": `QeTWQmUqSXwxScsRYD8C`,
	"right": `U8D4Q62fQwCZod88_OIx`,
	"info": `sGOKEtjb_4QuZq7djkzp`
};
export default ___CSS_LOADER_EXPORT___;
